import React, { useEffect } from 'react';
import { Stack, Typography } from '@mui/material';
import SupportAgentIcon from '@mui/icons-material/SupportAgent';
import LegacyIconButton from './LegacyIconButton';

function ChatButton({ component: Component, ...props }) {
  useEffect(() => {
    window.$crisp?.push(['do', 'chat:hide']);
  }, []);

  if (!window.$crisp) {
    return null;
  }

  function handleToggle() {
    if (window.$crisp?.is?.('chat:opened')) {
      window.$crisp.push(['do', 'chat:close']);
      window.$crisp.push(['do', 'chat:hide']);
    } else {
      window.$crisp.push(['do', 'chat:open']);
      window.$crisp.push(['do', 'chat:show']);
      const closeButton = document.querySelector('.crisp-client  div div div div[data-mode=chat] > div + span > span');
      if (closeButton) {
        closeButton.style.setProperty('top', 'max(10px , var(--gap-top))', 'important');
      }
    }
  }

  return (
    <Component {...props} onClick={handleToggle} />
  );
}

export default ChatButton;
